import React from 'react';
import { ReportType } from '../../clients';
import useGetFormColor from './useGetFormColor';

function useGetReportColor() {
  const { data: cabinEventColor } = useGetFormColor(ReportType.CabinEventReport);
  const { data: flightEventColor } = useGetFormColor(ReportType.FlightEventReport);
  const { data: dispatchColor } = useGetFormColor(ReportType.DispatchEventReport);
  const { data: safetyEventColor } = useGetFormColor(ReportType.SafetyEventReport);

  return {
    getFormColor: (reportType: ReportType | undefined) => {
      switch (reportType) {
        case ReportType.CabinEventReport:
          return cabinEventColor ?? 'gray';
        case ReportType.FlightEventReport:
          return flightEventColor ?? 'gray';
        case ReportType.DispatchEventReport:
          return dispatchColor ?? 'gray';
        case ReportType.SafetyEventReport:
          return safetyEventColor ?? 'gray';
        default: return 'gray';
      }
    },
  };
}

export default useGetReportColor;
